// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"211":"be1940b9","453":"86268708","499":"6a8a7bc4","729":"12b63773","947":"2d38015b"}[chunkId] + ".chunk.js";
};